document.addEventListener("DOMContentLoaded", function() {
    var links = document.getElementsByTagName('a');
    var pattern = new RegExp('^https?:\/\/(?!.*apsva\.us)');
    for (var i = 0; i < links.length; i++) {
      if (pattern.test(links[i].href)) {
        links[i].setAttribute('target', '_blank');
      }
    }
  }); 